import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import closeButton from 'src/assets/images/closeButton.png'

import useWindowDimensions from "src/hooks/useWindowDimensions"
import useAPI from "src/hooks/useApi"

import { MvmoTermsState, MvnoCheckValue, PCodeState, RequestIdState } from "src/recoil/common"
import { TelecomTypeState } from "src/recoil/join"
import { CertNumberSubmitState, PartnerState } from "src/recoil/ui"
import { MVNOPopupWrap, ModalBox, ModalWrap, PopupLayer, TermsCheckBox } from "src/styles/mvno"
import { CustomBtn } from "src/styles/common"

const MvnoModal = (props: any) => {
    const pCode = useRecoilValue(PCodeState);
    const { width } = useWindowDimensions()
    const { submit } = props
    const telecom = useRecoilValue(TelecomTypeState);
    const requestId = useRecoilValue(RequestIdState)
    const [mvnoCheckValue,setMvnoCheckValue] = useRecoilState(MvnoCheckValue)
    const mvnoTermsData = useRecoilValue(MvmoTermsState)
    const partner = useRecoilValue(PartnerState)
    const setCertNumberSubmit = useSetRecoilState(CertNumberSubmitState);
    const CertApi = useAPI('sendcaptchaexpress')

    const certInput = document.getElementById('certInput')
    const { mutateAsync: getSendOtp } = CertApi.useSetMutation({
      Telecom: telecom,
      PNumber: submit.phoneInput.value,
      PCode: pCode,
      RequestID: requestId,
    })

    const acceptKTTerms = (e: React.ChangeEvent<HTMLInputElement>) => {
      setMvnoCheckValue(e.target.checked)
    }
    const modalClose = () => {
      submit.modal.toggle() //toggle
      setMvnoCheckValue(false)
    }
    const checkTermTrue = () => {
      if (!mvnoCheckValue){
        if (window.confirm('서비스 이용을 위해 약관 동의가 필요합니다.\n모두 동의하시겠습니까?')){
          submit.modal.toggle()
          setMvnoCheckValue(true)
          submit.cert(getSendOtp)
          setCertNumberSubmit(true)
        }
      } else {
        submit.modal.toggle()
        setCertNumberSubmit(true)
        submit.cert(getSendOtp)
      }
      if (certInput) {
        setTimeout(() => {
          certInput.focus()
        }, 1000)
      }
    }
    return (
      submit.modal.isOpen && ( 
        <ModalWrap toggle={submit.modal.isOpen} zIndex={9990} width={`${width}px`} >
          <ModalBox onClick={(e: any) => e.stopPropagation()}>
            <PopupLayer>
              <MVNOPopupWrap className="popup_contents">
                <img src={closeButton} className="close-btn" alt="" onClick={modalClose} />
                <div className="top">
                  <h4 className="description">
                    KT MVNO(알뜰폰) 추가
                    <br />
                    약관 동의가 필요합니다.
                  </h4>
                  <h4 className="title">아래 약관 확인 후 동의해주세요.</h4>
                </div>
                <div className="terms-wrap">
                  <div className="check-wrap">
                    <input type="checkbox" id="terms-check"
                      onChange={acceptKTTerms}
                    />
                    <TermsCheckBox htmlFor="terms-check" isChecked={mvnoCheckValue}>
                      <p dangerouslySetInnerHTML={{ __html: decodeURIComponent(escape(atob(mvnoTermsData?.TermsTitle))), }} />
                      <i className="icon" />
                    </TermsCheckBox>
                  </div>
                  <div className="terms-contents-wrap">
                  <p className="terms-contents" dangerouslySetInnerHTML={{ __html: decodeURIComponent(escape(atob(mvnoTermsData?.Terms))), }} />
                  </div>
                </div>
                <CustomBtn
                  id="common_btn"
                  backgroundColor={partner.UiData.layoutsConfirm.submitBtn.backgroundColor}
                  borderRadius={"5px"}
                  width={width > 1200 ? "356px" : "328px"}
                  height={"44px"}
                  lineHeight="0px"
                  fontSize={"14px"}
                  fontFamily={
                    width > 1200
                      ? "NanumSquareNeoHeavy, sans-serif"
                      : "NotoSansBold, sans-serif"
                  }
                  onClick={checkTermTrue}
                >
                  <span>동의 및 인증번호 받기</span>
                </CustomBtn>
              </MVNOPopupWrap>
            </PopupLayer>
          </ModalBox>
        </ModalWrap>
      )
    )
}

export default MvnoModal